







import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import BusinessDay from '@/pages/TWMAfterHoursSettings/BusinessDay.vue'
import { BusinessHoursInterface } from '@/pages/TWMAfterHoursSettings/types/business-hours'


const dayKeys = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

@Component({
    components: {
        BusinessDay
    }
})
export default class BusinessHours extends Vue {
    dayKeys = dayKeys
    @Prop() value!: BusinessHoursInterface
    @Prop({ default: true }) disabled!: boolean

    @Emit('input')
    handleInput(): BusinessHoursInterface {
        return this.value
    }
}
